import { QueryFunction, useQuery } from '@tanstack/react-query';

import {
    GetDeviceAlertConfigurationOptionsResponse,
    GetDeviceAlertConfigurationPayload,
} from '@/api/customSensorAlerts/types';
import { axios } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';
import { SpotterIdQueryKey } from '@/common/types';

export const getDeviceAlertConfigurationOptions: QueryFunction<GetDeviceAlertConfigurationOptionsResponse> = async ({
    queryKey,
    signal,
}): Promise<GetDeviceAlertConfigurationOptionsResponse> => {
    const spotterId = (queryKey as SpotterIdQueryKey)[1].spotterId;
    return axios.get(`/user-rest/devices/${spotterId}/alert-configurations/options`, { signal });
};

type UseDeviceAlertConfigurationOptions = {
    config?: QueryConfig<typeof getDeviceAlertConfigurationOptions>;
} & GetDeviceAlertConfigurationPayload;

export const useDeviceAlertConfigurationOptions = ({ config = {}, spotterId }: UseDeviceAlertConfigurationOptions) => {
    return useQuery<GetDeviceAlertConfigurationOptionsResponse>({
        queryKey: ['device-alert-configuration-options', { spotterId }],
        queryFn: getDeviceAlertConfigurationOptions,
        staleTime: 1000 * 60 * 5, // 5 minutes
        ...config,
    });
};
